// Código digitado en la fila de la nota (ronda 1): «2304» + Enter agrega la línea DIRECTO si el código
// es exacto y único (SKU o código de barras); si no existe o hay varias coincidencias, la nota abre el
// buscador (F3). La línea se agrega en la presentación BASE (unidad base).
import { api, ErrorApi } from '../api/cliente';
import type { Presentacion, ProductoEncontrado } from '../api/contratos';

export interface ProductoExacto {
  producto: ProductoEncontrado;
  base: Presentacion;
}

async function presentacionBase(productoId: string): Promise<Presentacion | null> {
  const pres = await api.get<Presentacion[]>(`/productos/${productoId}/presentaciones`);
  const vendibles = pres.filter((p) => p.vendible && p.activa);
  return vendibles.find((p) => p.es_base) ?? null;
}

/** El producto si el código es EXACTO y único y se vende; null en cualquier otro caso. */
export async function resolverCodigo(
  empresaId: string,
  texto: string,
): Promise<ProductoExacto | null> {
  const t = texto.trim();
  if (!t) return null;
  const candidatos = await api.get<ProductoEncontrado[]>('/productos', {
    query: { empresaId, estado: 'activo', texto: t, limite: 20, desplazamiento: 0 },
  });
  let exactos = candidatos.filter(
    (p) => p.sku.toUpperCase() === t.toUpperCase() && p.vendible !== false,
  );
  if (!exactos.length && /^\d{8,}$/.test(t)) {
    // Código de barras: lo resuelve el catálogo (exacto por definición).
    try {
      const porCodigo = await api.get<ProductoEncontrado & { empresa_id: string }>(
        `/productos/codigo/${encodeURIComponent(t)}`,
      );
      // El catálogo ya filtró por las empresas del usuario; la búsqueda devuelve la ficha base.
      if (porCodigo) exactos = [{ ...porCodigo, vendible: true }];
    } catch (e) {
      if (!(e instanceof ErrorApi) || e.status !== 404) throw e;
    }
  }
  if (exactos.length !== 1) return null;
  const producto = exactos[0]!;
  const base = await presentacionBase(producto.id);
  return base ? { producto, base } : null;
}
